import { createContext } from 'react'

const ModalSidebarContext = createContext({ setToBackdrop: () => {} })

export default ModalSidebarContext
